<div class="table-responsive">
  <div *ngIf="config?.maxRows && (data.length > config.maxRows)" class="d-flex justify-content-end m-1">
    <span class="table-count"> 1 - {{ config.maxRows }} of {{ data.length }} </span>
    <i class="view-all" (click)="viewAll()" (keydown)="viewAll()"> View All </i>
  </div>
  <table class="table table-hover">
    <!-- <thead>
      <tr>
        <th
          class="header-4"
          *ngFor="let column of columns"
          [ngStyle]="column.headerStyles"
        >
          {{ column.display_name }}
        </th> 
      </tr>
    </thead> -->
    <thead>
      <tr>
        <th
          class="header-4"
          *ngFor="let column of columns"
          [ngStyle]="column.headerStyles"
        >
           @if(column.filter){
            <select [(ngModel)]="selectedImpact" (change)="onDropdownChange()">
              <!-- <option value="">Select Impact</option> -->
              <option *ngFor="let option of dropdownOptions" [value]="option">
                {{ option }}
              </option>
            </select>
            } @else{
  
            <div
              class="header-container"
            >
              <span>{{ column.display_name }}</span>
              <mat-icon (click)="sortTable(column.key)" *ngIf="column.sortable" (keydown.enter)="sortTable(column.key)">
                {{
                  sortedColumn === column.key && sortOrder === "asc"
                    ? "arrow_upward"
                    : "arrow_downward"
                }}
              </mat-icon>
            </div>
            }
        </th>
        
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of getData(); let rowIndex = index">
        <ng-container *ngIf="columns && columns[0]?.rowspan">
          <td
            *ngIf="shouldRenderRowspan(data, rowIndex)"
            [attr.rowspan]="getRowspan(data, row.impact)"
            class="general-text-2"
            [ngStyle]="columns[0].bodyStyles"
          >
            <!-- {{ row.impact }} -->
          </td>
        </ng-container>
        <td
          *ngFor="let column of getColumns(columns); let colIndex = index"
          class="general-text-2"
          [ngStyle]="column.bodyStyles"
        >
          <ng-container [ngSwitch]="column?.type">
            <ng-container *ngSwitchCase="'object-array'">
              <div
                class="nested-data"
                *ngFor="let item of getNestedData(row, column.key)"
              >
                <div *ngFor="let meta of column.meta">
                  <strong>{{ meta.display_name }}:</strong>
                  {{ getNestedData(item, meta.key) }}
                </div>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'orderd-list'">
              <app-common-list
                [items]="getNestedData(row, column.key)"
                [isOrderedList]="true"
              >
              </app-common-list>
            </ng-container>
            <ng-container *ngSwitchCase="'textarea'">
              <textarea
                class="general-text-2"
                [(ngModel)]="row[column.key]"
                (ngModelChange)="onTextareaChange(row, column.key, $event)"
              ></textarea>
            </ng-container>
            <ng-container *ngSwitchDefault>
              {{ getNestedData(row, column.key) }}
            </ng-container>

            <ng-container *ngSwitchCase="'lozenge'">
              <span
                class="general-text-2"
                [(ngModel)]="row[column.key]"
                [ngClass]="getLozengeClass(row[column.key])"
              >{{row[column.key]}}</span>
            </ng-container>
          </ng-container>
        </td>
      </tr>
    </tbody>
  </table>
</div>
